export default {
    mounted () {
        const body = document.querySelector('body')
        const slider = document.querySelector('.board__inner')
        let isDown = false
        let startX
        let scrollLeft

        body.addEventListener('mousedown', (event) => {
            if ($(event.target).parents('.board__column').length === 0) {
                isDown = true
                slider.classList.add('is-grabbing')
                startX = event.pageX - slider.offsetLeft
                scrollLeft = slider.scrollLeft
            }
        })

        body.addEventListener('mouseleave', () => {
            isDown = false
            slider.classList.remove('is-grabbing')
        })

        body.addEventListener('mouseup', () => {
            isDown = false
            slider.classList.remove('is-grabbing')
        })

        slider.addEventListener('mousemove', (event) => {
            if (!isDown) return
            event.preventDefault()
            const x = event.pageX - slider.offsetLeft // tells us where the cursor is when they move to the left or the right. Same code as above. Need it to recalculate the position everytime we move the mouse.
            const walk = (x - startX) * 1 // how far we have deviated from that initial point. Multiply by three to speed up the scroll over effect.
            slider.scrollLeft = scrollLeft - walk
        })
    }
}
